import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnDestroy,
} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { first, Observable, Subscription } from 'rxjs';
import { ConfigService } from 'src/app/services/config-service/config.service';

import { LOGIN_PAGES } from '../enum-login-pages';
import { MixpanelService } from '../../../services/mixpanel-service/mixpanel.service';
import { DeviceService } from '../../../services/device-service/device.service';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss'],
})
export class EmailComponent implements OnInit, OnDestroy {
  @Output() nextStep = new EventEmitter<number>();
  @Output() currentEmail = new EventEmitter<string>();
  @Output() userLocked = new EventEmitter<boolean>();
  @Input() email = '';
  displayErrorAccountNotExists = false;
  loading = false;
  private deviceTypeSubscription: Subscription | undefined;
  deviceType = '';

  frmLogin = new FormGroup({
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(
        '[a-zA-Z0-9._-]{3,}@[a-zA-Z0-9.-]{3,}[.][a-zA-Z]{2,4}'
      ),
    ]),
  });

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
    private mixpanelService: MixpanelService,
    private deviceService: DeviceService
  ) {}

  ngOnInit(): void {
    this.deviceTypeSubscription = this.deviceService
      .getDeviceTypeObservable()
      .subscribe((type) => {
        this.deviceType = type;
      });
    this.frmLogin.controls['email'].setValue(this.email);
    if (this.email) {
      this.mixpanelService.init(this.email);
    }
  }

  signUp() {
    this.nextStep.emit(LOGIN_PAGES.SIGN_UP_SCREEN);
  }

  checkEmail() {
    this.loading = true;

    const params = new HttpParams().set('email', this.frmLogin.value.email);

    this.mixpanelService.init(this.frmLogin.value.email);
    this.mixpanelService.track(this.frmLogin.value.email, 'USER_LOGIN');

    this.mixpanelService.track({
      id: this.frmLogin?.value?.email,
      eventName: 'Email Entered in login',
      eventDisplayName: this.frmLogin?.value?.email,
      kpi: 'User Engagement',
      trigger: 'On Button Click',
      eventDefinition: 'User clicks the first Next button',
      propertyType: 'Event Property',
      propertyDefinition: 'Text entered email',
    });

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    const submission$: Observable<any> = this.httpClient.post(
      this.configService.validateAccountURL,
      null,
      { headers: headers, params: params }
    );
    submission$.pipe(first()).subscribe({
      next: (response: any) => {
        if (response.salesforce_disabled) {
          this.loading = false;
          this.mixpanelService.register(this.frmLogin?.value?.email);
          this.mixpanelService.track({
            id: this.frmLogin.value.email,
            eventName: 'User Account Salesforce Disabled',
            eventDisplayName: this.frmLogin?.value?.email,
            kpi: 'User Engagement',
            trigger: 'On Button Click',
            eventDefinition: 'User clicks the first Next button',
            propertyType: 'Event Property',
            propertyDefinition: 'Button checkEmail',
          });

          this.nextStep.emit(LOGIN_PAGES.ACCESS_DENIED);
          return;
        }

        if (!response.validated) {
          this.loading = false;
          this.displayErrorAccountNotExists = true;
          const email = this.frmLogin.value.email;
          this.mixpanelService.track({
            id: email,
            eventName: 'Account not exists',
            eventDisplayName: email,
            kpi: 'Form Completion Rate',
            trigger: 'On Field Entry',
            eventDefinition: 'User enters an email in the form field',
            propertyType: 'Event Property',
            propertyDefinition: 'Field checkEmail',
          });

          return;
        }
        const submission$: Observable<any> = this.httpClient.post(
          this.configService.firstTimeUserURL,
          null,
          { headers: headers, params: params }
        );
        submission$.pipe(first()).subscribe({
          next: (response: any) => {
            if (response.first_time) {
              const email = this.frmLogin.value.email;

              this.mixpanelService.track({
                id: email,
                eventName: 'Email Entered in login',
                eventDisplayName: email,
                kpi: 'User Engagement',
                trigger: 'On Button Click',
                eventDefinition: 'User clicks the first Next button',
                propertyType: 'Event Property',
                propertyDefinition: 'Text entered email',
              });

              this.nextStep.emit(LOGIN_PAGES.EMAIL_SENT_SCREEN);
            } else {
              const email = this.frmLogin.value.email;
              this.mixpanelService.register(email);
              this.mixpanelService.track({
                id: email,
                eventName: 'Password Entered',
                eventDisplayName: email,
                kpi: 'Form Completion Rate',
                trigger: 'On Field Entry',
                eventDefinition: 'User enters a password in the form field',
                propertyType: 'Event Property',
                propertyDefinition: 'Field Label',
              });
              this.nextStep.emit(LOGIN_PAGES.PASSWORD);
              this.userLocked.emit(response.locked);
            }
            this.currentEmail.emit(this.frmLogin.value.email);
            this.loading = false;
          },
          error: ({ error }) => {
            const email = this.frmLogin.value.email;
            // Modal - next_button2_click
            this.mixpanelService.track({
              id: email,
              eventName: 'next button 2 click',
              eventDisplayName: email,
              kpi: 'Conversion Rate',
              trigger: 'On Button Click',
              eventDefinition:
                'User clicks the second Next button SIGN_IN_ERROR',
              propertyType: 'Event Property',
              propertyDefinition: 'Button SIGN_IN_ERROR',
            });
            this.loading = false;
          },
        });
      },
      error: ({ error }) => {
        this.mixpanelService.track(
          this.frmLogin.value.email,
          'SIGN_IN_ERROR_FINAL :' + error?.message
        );
        this.loading = false;
      },
    });
  }

  ngOnDestroy() {
    if (this.deviceTypeSubscription) {
      this.deviceTypeSubscription.unsubscribe();
    }
  }
}
